import React, { memo } from 'react';
import { useMatches, Navigate, Outlet } from 'react-router-dom';

import { root } from '~/preloaded';
import { useAppSelector } from '~/store';
import { navigationSelector } from '~/store/selectors/navigationSelectors';

import type { UIMatch, RouteObject } from 'react-router-dom';

interface INavigationGuardProps {
  children?: React.ReactNode;
}

const NavigationGuard: React.FC<INavigationGuardProps> = () => {
  const navigationContext = useAppSelector(navigationSelector);
  const matches = useMatches();

  const isRoot = matches.length <= 1;

  for (let i = matches.length - 1; i >= 0; i--) {
    const currentRoute = matches[i] as UIMatch<unknown, RouteObject['handle']>;
    const redirectUrl = currentRoute?.handle?.navigationGuard?.(navigationContext);

    if ((isRoot || (!isRoot && currentRoute.pathname !== root)) && typeof redirectUrl === 'string') {
      return <Navigate to={`${root}${redirectUrl}`} replace />;
    }
  }

  return <Outlet />;
};

export default memo(NavigationGuard);
